import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Card, CardActions, CardContent, Grid} from "@mui/material";
import {useHasScope} from "../../../../../config/globalConfig";
import {
    CLUSTER_ADD_SUBSCRIPTION_CONFIGURATION,
    CLUSTER_EDIT_SUBSCRIPTION_CONFIGURATION
} from "../../../utils/FinanceScope";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";
import {
    useClusterSubscriptionConfigurationRepository
} from "../../../api/repositories/ClusterSubscriptionConfigurationRepository";
import SubscriptionConfigurationInstances from "../sections/SubscriptionConfigurationInstances";
import {useParams} from "react-router-dom";

const SubscriptionConfigurationTable = ({legalEntity, dealer}: {legalEntity: string, dealer: string}) => {

    const {t} = useTranslation("finance", {keyPrefix: "clusters"});
    const hasScope = useHasScope;
    const {dispatchGlobalData} = useContext(GlobalContext);
    const {
        getClusterConfiguration,
        createClusterConfiguration,
        updateClusterConfiguration,
        getDefaultConfiguration
    } = useClusterSubscriptionConfigurationRepository();
    const [enableUpdate, setEnableUpdate] = useState<boolean>(false);
    const [enableCreation, setEnableCreation] = useState<boolean>(false);
    const [firstConfiguration, setFirstConfiguration] = useState<boolean>(false);
    const [data, setData] = useState<any[]>([]);
    const {id} = useParams();


    useEffect(() => {
        reloadPage();
    }, []);

    function reloadPage() {
        getClusterConfiguration(id).then((response: any) => {
            let data = response.result;
            if (data.length > 0) {
                let originData = [...data]
                setData(originData);
            } else {
                let defaultConfiguration = getDefaultConfiguration()
                setData(defaultConfiguration.content.map(x => {
                    x.legalEntity = legalEntity;
                    x.dealer = dealer;
                    return x;
                }))
                setFirstConfiguration(true)
            }

        });
    }

    const saveData = () => {
        updateClusterConfiguration(id, data!)
            .then((response) => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("subscriptions.successUpdate"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
                reloadPage();
                setEnableUpdate(false)
            })
            .catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("subscriptions.errorUpdate"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
            });
    };

    const createConfiguration = () => {
        createClusterConfiguration(id, data!)
            .then((response) => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("subscriptions.successCreation"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
                window.location.reload();
            })
            .catch(() => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("subscriptions.errorCreation"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        },
                    },
                });
            });
    };


    return (
        <>
            <Card variant="outlined">
                <CardContent>
                    <>
                        <Grid container columnSpacing={3}>
                            <Grid item xs={3}>
                                <p style={{fontWeight: 'bold'}}> {t("subscriptions.printoutType")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p style={{fontWeight: 'bold'}}> {t("subscriptions.algorithm")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p style={{fontWeight: 'bold'}}> {t("subscriptions.commissionType")} </p>
                            </Grid>
                            <Grid item xs={3}>
                                <p style={{fontWeight: 'bold'}}> {t("subscriptions.coefficient")} </p>
                            </Grid>
                        </Grid>
                        {data.map((row: any, index) =>
                            <SubscriptionConfigurationInstances
                                row={row}
                                data={data}
                                index={index}
                                setData={setData}
                                setEnableUpdate={setEnableUpdate}
                                setEnableCreation={setEnableCreation}
                                isFirstConfiguration={firstConfiguration}
                            />
                        )}
                        <Grid item xs={3}> </Grid>
                    </>
                </CardContent>
                <CardActions sx={{justifyContent: "flex-end"}}>
                    {firstConfiguration ?
                        <Button
                            onClick={createConfiguration}
                            disabled={!hasScope(CLUSTER_ADD_SUBSCRIPTION_CONFIGURATION) || !enableCreation}
                            size="small"
                        >
                            {t("subscriptions.create")}
                        </Button>
                        :
                        <Button
                            onClick={saveData}
                            disabled={!hasScope(CLUSTER_EDIT_SUBSCRIPTION_CONFIGURATION) || !enableUpdate}
                            size="small"
                        >
                            {t("subscriptions.update")}
                        </Button>
                    }
                </CardActions>
            </Card>
        </>
    );
};

export default SubscriptionConfigurationTable;
